/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import AppContainer from "../../../../Components/Structure/AppContainer";
import AdminContext from "../../../../Context/AdminContext";
import useStateCallback from "../../../../util/customHooks/useStateCallback";
import TableHeader from "../../../../Components/Common/TableHeader";
import toast, {Toaster} from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket, faUserLock } from "@fortawesome/free-solid-svg-icons";
import RemoteLogOut from "../../../RemoteLogOut";
import AddVendor from "../../../../Components/Vendors/AddVendor";
import Loader from "../../../../Components/Common/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ajaxStudent from "../../../../util/remote/ajaxStudent";
import UpdateVendorSchool from "../../../../Components/Vendors/UpdateVendorSchool";
import UpdateDisbursementNumber from "../../../../Components/Vendors/UpdateDisbursementNumber";
import SchoolContext from "../../../../Context/SchoolContext";
import Select from "react-select";
import Pagination from "../../../../Components/Common/Pagination";

function ListVendorsPage() {

    const {vendorListByPage, getVendorListByPage, loading2, loading3, meta, page, query, first, school, setSchool, setQuery, setPage, searchVendors} = useContext(AdminContext);
    const [modal, setModal] = useStateCallback(false);
    const {schoolList} = useContext(SchoolContext);

    useEffect(() => {
        if (query) {
          searchVendors();
        } else {
          getVendorListByPage(page);
        }
      }, [page]);

    const handleReset = (e) => {
    e.preventDefault();
    setVendors(e);
  };

  
const handleVendorChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setPage(1);
    if (value === '') {
      setVendors(e);
    }
};

const setVendors = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setPage(1);
    getVendorListByPage(1);
    
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

    const handleAdd=()=>{
      setModal(false, ()=>setModal(<AddVendor g={getVendorListByPage}  isOpen={true}/>))
    }

    const remoteLogout = (e, item) => {
      setModal(false, () =>
        setModal(
          <RemoteLogOut
            userID={item.user_id}
            isOpen={true}
          />
        )
      );
    };

    const getDefaultPin = async (e,item) => {
      e.preventDefault()
      const server_response = await ajaxStudent.setDefaultPin(item.user_id);
      if (server_response.status === "OK") {
        toast.success(server_response.message, {duration: 10000});
        getVendorListByPage();
      }
    };

    const handleUpdate=(e,item)=>{
      setModal(false, ()=>setModal(<UpdateVendorSchool adminID={item.vendor_id} g={getVendorListByPage} isOpen={true}/>))
    }

    const handleUpdateDisbursement=(e,item)=>{
      setModal(false, ()=>setModal(<UpdateDisbursementNumber accountID={item.user_id} g={getVendorListByPage} isOpen={true}/>))
    }

  return (
    <AppContainer title="Vendors">
      <Toaster position="top-center" reverseOrder={false} />

    {modal}
      <div className="row">
        <div className="col-lg-12 col-md-12 mt-3">
        <div className="card height-auto">
   
      <div className="card-body">
        <TableHeader
            title="Vendors List"
            subtitle="List of all the different vendors" 
            viewButton={
                <Link onClick={handleAdd} className="btn btn-info" style={{float:"right"}}>Add Vendor</Link>
                   
            }   
              />
        {/* Search form */}
        {/* Table */}
        <form className="mg-t-20" onSubmit={searchVendors}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
          <div className="col-lg-6 mt-2">
              <input
                type="text"
                placeholder="Enter vendor name..."
                style={{ border: "1px solid grey" }}
                value={query}
                onChange={handleVendorChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-6 mt-2">
            <Select
                onChange={(e) => setSchool(e.school_id)}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                    Array.isArray(schoolList) &&
                    schoolList.find((value) => value.school_id === school)
                }
            />
            </div>
            
            
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
      </form>

        <div className="border-top mt-3"></div>
        <div className="table-responsive">
          {loading3 || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th>No</th>
                <th>Names</th>
                <th>Username</th>
                <th>Disbursement Number</th>
                <th>School Name</th>
                <th>Account Status</th>
                <th>Actions</th>

                </tr>
            </thead>
            <tbody>
                {vendorListByPage.length > 0 ? (
                    vendorListByPage.map((item, index) => (
                    <tr key={index}>
                          <td>{index + first + 1}</td>
                          <td><Link to={`/vendors/profile/${item.vendor_id}/${item.user_id}`}>{item.full_name}
                              </Link></td>
                          <td>{item.username}</td>
                          <td>{item.phone_number}</td>

                          <td>{item.school_name}</td>

                          <td>{item.is_secure==="1"?<span class="badge badge-success">SECURED</span>:
                                                    <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip id="refresh-tooltip">Account is not secure!</Tooltip>}>
                                                        <span class="badge badge-danger">{item.default_pin}</span></OverlayTrigger>}
                          </td>
                          <td>
                            <div className="dropdown">
                              <Link
                                to="#"
                                className="dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="false">
                                <span className="flaticon-more-button-of-three-dots"></span>
                              </Link>
                              <div className="dropdown-menu dropdown-menu-right">
                                <Link
                                  className="dropdown-item"
                                  to="#"
                                  onClick={(e) => getDefaultPin(e,item)}>
                                  <FontAwesomeIcon icon={faUserLock} style={{ color: "teal", marginRight: "3px" }} />
                                  Set Default Pin
                              </Link>
                                <Link
                                  className="dropdown-item"
                                  to="#"
                                  onClick={(e) => handleUpdate(e,item)}>
                                  <i
                                          className="far fa-edit mr-1"
                                          style={{ color: "orange" }}
                                        ></i>
                                  Change School
                                </Link>
                                <Link
                              className="dropdown-item"
                              to="#"
                              onClick={(e) => remoteLogout(e,item)}>
                              <FontAwesomeIcon icon={faArrowRightFromBracket} style={{ color: "red", marginRight: "3px" }} />
                                Remote Log-Out
                                </Link>
                                <Link
                              className="dropdown-item"
                              to="#"
                              onClick={(e) => handleUpdateDisbursement(e,item)}>
                              <i
                                          className="far fa-edit mr-1"
                                          style={{ color: "black" }}
                                        ></i>
                                Update Disbursement Number
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                            No vendors registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
          
        
      </div>
    </div>
        </div>
      </div>
    </AppContainer>
  );
}

export default ListVendorsPage;
